/**
 * Hand Easy Product Addons' own quick-view "Add to cart" (#spicegems-qv-add-btn)
 * back to the theme. It posts to /cart/add.js and fires nothing the theme
 * hears, so the drawer never opens. See README.md, "Untested on purpose".
 *
 * Wraps fetch because the request is the only observable signal: the app
 * dispatches no event and toggles an existing node rather than inserting one.
 * Armed by a click on the app's button and disarmed by the next /cart/add or
 * a timeout, so the theme's own adds -- which already dispatch
 * ajaxProduct:added -- are not rebuilt twice. Reading res.ok does not consume
 * the body, and the app gets the original promise.
 *
 * Delegated from the document because the app injects (and re-injects) the
 * widget after this runs. ES5 and `var` to match the theme's other scripts.
 */
(function () {
  var ADD_BUTTON = '#spicegems-qv-add-btn, .spicegems-add-to-cart';
  var DIALOG = '#spicegems-product_quickview';
  var DIALOG_CLOSE = '.spicegems-modal-close';
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;

  // Long enough for a slow cart round trip, short enough that an abandoned
  // click cannot capture an unrelated add later.
  var ARM_MS = 15000;

  var armedAt = 0;

  function isArmed() {
    return armedAt && Date.now() - armedAt < ARM_MS;
  }

  function handOver() {
    // The app's own close button rather than hiding the box, so the app also
    // releases its scroll lock. Closed first so the drawer does not open
    // behind the app's overlay.
    var dialog = document.querySelector(DIALOG);
    var close = dialog && dialog.querySelector(DIALOG_CLOSE);
    if (close) {
      close.click();
    } else if (dialog) {
      dialog.style.display = 'none';
    }

    // Parity with theme.AjaxProduct.success: a page cart has no drawer.
    var settings = window.theme && theme.settings;
    if (settings && settings.cartType === 'page' && theme.routes && theme.routes.cartPage) {
      window.location = theme.routes.cartPage;
      return;
    }

    // theme.CartDrawer rebuilds the cart and opens the drawer on this.
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

  // Capture, so the arm is set before the app's own click handler runs.
  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || !target.closest) return;
    if (!target.closest(ADD_BUTTON)) return;
    armedAt = Date.now();
  }, true);

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var response = nativeFetch.apply(this, arguments);

    if (isArmed() && CART_ADD.test(url)) {
      armedAt = 0;
      response.then(function (res) {
        // A refused add leaves the app's dialog open with its own error.
        if (res && res.ok) handOver();
      }).catch(function () {});
    }

    return response;
  };
})();
